export default __webpack_public_path__ + "static/media/SEB.969cffc2.svg";